import React, { useEffect, useState } from 'react';
import { CTAButton, CHECKOUT_URL } from './CTAButton';
import { Star, Shield } from 'lucide-react';
export function PricingCard() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 1,
    minutes: 30,
    seconds: 5
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          hours,
          minutes,
          seconds
        } = prev;
        if (seconds > 0) {
          seconds--;
        } else if (minutes > 0) {
          minutes--;
          seconds = 59;
        } else if (hours > 0) {
          hours--;
          minutes = 59;
          seconds = 59;
        } else {
          hours = 1;
          minutes = 30;
          seconds = 5;
        }
        return {
          hours,
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <section id="pricing" className="py-8 px-4 sm:px-6 bg-white border-y-4 border-brand-pool/20 scroll-mt-2" data-id="element-130">
      <div className="text-center mb-5" data-id="element-131">
        <p className="text-xs font-bold text-brand-orange uppercase tracking-widest mb-2" data-id="element-132">
          SPECIAL OFFER — COMPLETE 6-IN-1 PACK
        </p>
        <p className="text-sm font-bold text-brand-navy mb-3 leading-tight" data-id="element-133">
          Access the system now and transform your swim lessons today.
        </p>
        <div className="inline-block bg-brand-navy text-white px-3 py-1 rounded shadow-sm mb-4" data-id="element-134">
          <p className="font-bold text-sm tracking-wide uppercase" data-id="element-135">
            SWIMMING COACH READY™ 6-in-1 Box Set
          </p>
        </div>
        <a href={CHECKOUT_URL} className="block cursor-pointer" data-id="element-136">
          <img src="https://cdn.magicpatterns.com/uploads/aTXo3ByxQ5iocpXC8cAKKr/ChatGPT-Image-17-jun-2026_-06_41_45-p.m..webp" alt="Swimming Coach Ready 6-in-1 Box Set" className="w-full max-w-[240px] mx-auto object-contain drop-shadow-xl mb-4" data-id="element-137" />
        </a>
      </div>

      <div className="bg-brand-gray border-4 border-brand-navy rounded-lg p-5 text-center relative mb-4 shadow-xl" data-id="element-138">
        <div className="mb-4" data-id="element-139">
          <p className="text-sm font-bold text-brand-navy/60 mb-1" data-id="element-140">
            Normal Price: <span className="line-through" data-id="element-141">$97 USD</span>
          </p>
          <p className="text-base font-black text-brand-orange mb-2 uppercase tracking-wide" data-id="element-142">
            🔥 72% OFF — LAUNCH OFFER
          </p>
          <p className="text-5xl font-heading font-black text-brand-navy mb-1 leading-none" data-id="element-143">
            $27 USD
          </p>
          <p className="text-[10px] font-bold text-brand-navy/60 uppercase tracking-wider" data-id="element-144">
            Pay in your local currency
          </p>
        </div>

        <div className="bg-white border-2 border-brand-orange/30 rounded-md p-3 mb-5" data-id="element-145">
          <p className="text-xs font-bold text-brand-orange mb-2 uppercase tracking-tight" data-id="element-146">
            🔥 Last chance! The price increases when the timer ends.
          </p>
          <div className="flex justify-center gap-2" data-id="element-147">
            <div className="text-center" data-id="element-148">
              <div className="bg-brand-navy text-white font-heading text-2xl font-black px-2 py-1.5 rounded shadow-inner leading-none min-w-[44px]" data-id="element-149">
                {String(timeLeft.hours).padStart(2, '0')}
              </div>
              <p className="text-[9px] font-bold text-brand-navy/70 mt-1 tracking-wider uppercase" data-id="element-150">
                HOURS
              </p>
            </div>
            <div className="text-xl font-black text-brand-navy mt-1" data-id="element-151">:</div>
            <div className="text-center" data-id="element-152">
              <div className="bg-brand-navy text-white font-heading text-2xl font-black px-2 py-1.5 rounded shadow-inner leading-none min-w-[44px]" data-id="element-153">
                {String(timeLeft.minutes).padStart(2, '0')}
              </div>
              <p className="text-[9px] font-bold text-brand-navy/70 mt-1 tracking-wider uppercase" data-id="element-154">
                MINUTES
              </p>
            </div>
            <div className="text-xl font-black text-brand-navy mt-1" data-id="element-155">:</div>
            <div className="text-center" data-id="element-156">
              <div className="bg-brand-navy text-white font-heading text-2xl font-black px-2 py-1.5 rounded shadow-inner leading-none min-w-[44px]" data-id="element-157">
                {String(timeLeft.seconds).padStart(2, '0')}
              </div>
              <p className="text-[9px] font-bold text-brand-navy/70 mt-1 tracking-wider uppercase" data-id="element-158">
                SECONDS
              </p>
            </div>
          </div>
        </div>

        <CTAButton data-id="element-159">🚀 YES, I WANT THE 6-IN-1 PACK</CTAButton>
      </div>

      <div className="flex flex-col sm:flex-row justify-center items-center gap-2 sm:gap-6 text-xs text-brand-navy font-bold" data-id="element-160">
        <div className="flex items-center gap-1.5" data-id="element-161">
          <Star className="w-4 h-4 fill-brand-orange text-brand-orange" data-id="element-162" />
          <span data-id="element-163">4.9/5 — Verified Reviews</span>
        </div>
        <div className="flex items-center gap-1.5" data-id="element-164">
          <Shield className="w-4 h-4 text-brand-pool" data-id="element-165" />
          <span data-id="element-166">7-Day Guarantee — Zero Risk</span>
        </div>
      </div>
    </section>;
}